var _g, _circle, _g2, _circle2, _path, _path2, _circle3, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgTradeNEarn = function SvgTradeNEarn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_13445)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.828,
    cy: 27.828,
    r: 27.172,
    fill: "url(#paint0_linear_264_13445)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_13445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 55,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.172,
    cy: 27.828,
    r: 27.172,
    fill: "url(#paint1_linear_264_13445)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_13445)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_13445)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -6.489,
    cy: 42.098,
    rx: 11.234,
    ry: 10.463,
    fill: "#95F0FB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_264_13445)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.847,
    cy: 59.233,
    rx: 10.847,
    ry: 10.103,
    fill: "#EDA54D"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.828,
    cy: 27.828,
    r: 26.922,
    stroke: "url(#paint2_linear_264_13445)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.098 23.68s11.406-7.224 21.539-.78c0 0-3.43-13.121-23.618-7.769L22.032 11l-9.068 11.484 13.225 5.768-1.091-4.573Z",
    fill: "url(#paint3_linear_264_13445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.503 32.747s-11.406 7.223-21.539.78c0 0 3.43 13.12 23.618 7.768l.987 4.105 9.068-11.484-13.225-5.742 1.091 4.573Z",
    fill: "#181717"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 12,
    fill: "url(#paint4_linear_264_13445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.21 42.467c.43-.151.914-.282 1.323-.378.409-.097 3.387-.416 3.387-.416l-.64-.614s-2.485-.995-3.112-.98c-.995.001-1.925.531-3.05 1.046-1.071.535-2.015.863-2.67 1.616-.424.465-1.313 3.004-1.313 3.004l.06.834 2.592-2.274c.362-.302.757-.528 1.153-.754l4.312 9.546 2.325-1.064-4.366-9.566Z",
    fill: "#171717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 51c2.94-.615 3.45-1.115 4.077-4 .627 2.885 1.176 3.385 4.076 4-2.94.615-3.449 1.115-4.076 4-.627-2.885-1.176-3.385-4.077-4Z",
    fill: "#171717"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_13445",
    x1: 29.828,
    y1: 0.655,
    x2: 29.828,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_13445",
    x1: 30.172,
    y1: 0.655,
    x2: 30.172,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_13445",
    x1: 29.828,
    y1: 0.655,
    x2: 29.828,
    y2: 25.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_13445",
    x1: 29.8,
    y1: 11,
    x2: 29.8,
    y2: 28.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_264_13445",
    x1: 47.5,
    y1: 35,
    x2: 47.5,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_13445",
    x: -3.345,
    y: -5.345,
    width: 66.345,
    height: 66.345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_13445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_13445",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_13445",
    x: -43.723,
    y: 5.634,
    width: 74.468,
    height: 72.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_13445"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_264_13445",
    x: -7,
    y: 23.13,
    width: 73.693,
    height: 72.205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_13445"
  })))));
};
export default SvgTradeNEarn;